export default class BackStockProduct {
    id: number;
    shelfCost: number;
    storeId: number;
    storeName: string;
    productSku: string;
    beginDeductionTime?: Date;
    creationTime: Date;
    deductIntegral: number;
    deductionCycle: string;
    lastModificationTime?: Date;
    logisticsNumber: string;
    productImgGuid: string;
    productName: string;
    productType: number;
    userCode: string;
    totalStorage: number;
    totalOutgoing: number;
    inventory: number;
    shelfPosition: string;
    onlyOneShelfCost: string;
    barCode: string;
}